import { data } from "../../mockData/_orders-mock";
import CallApi from "../../util/CallApi";

export const FETCH_ORDERS = "FETCH_ORDERS";
export const FETCH_ORDERS_SUCCESS = "FETCH_ORDERS_SUCCESS";
export const FETCH_ORDERS_FAILURE = "FETCH_ORDERS_FAILURE";

export const DELETE_ORDERS = "DELETE_ORDERS";
export const DELETE_ORDERS_SUCCESS = "DELETE_ORDERS_SUCCESS";
export const DELETE_ORDERS_FAILURE = "DELETE_ORDERS_FAILURE";

export const TOGGLE_DOC_MODAL = "TOGGLE_DOC_MODAL";
export const TOGGLE_DETAIL_MODAL = "TOGGLE_DETAIL_MODAL";

export const UPDATE_DOC = "UPDATE_DOC";
export const UPDATE_DOC_SUCCESS = "UPDATE_DOC_SUCCESS";
export const UPDATE_DOC_FAILURE = "UPDATE_DOC_FAILURE";

export const ADD_ORDER_ITEM = "ADD_ORDER_ITEM";
export const ADD_ORDER_ITEM_SUCCESS = "ADD_ORDER_ITEM_SUCCESS";
export const ADD_ORDER_ITEM_FAILURE = "ADD_ORDER_ITEM_FAILURE";

export const UPDATE_DETAIL = "UPDATE_DETAIL";
export const UPDATE_DETAIL_SUCCESS = "UPDATE_DETAIL_SUCCESS";
export const UPDATE_DETAIL_FAILURE = "UPDATE_DETAIL_FAILURE";

export const ORDER_APPROVE = "ORDER_APPROVE";
export const ORDER_APPROVE_SUCCESS = "ORDER_APPROVE_SUCCESS";
export const ORDER_APPROVE_FAILURE = "ORDER_APPROVE_FAILURE";

const mockup = false; // from folder mockup or not
const callApi = new CallApi();

export const fetchOrders = params => dispatch => {
  dispatch({ type: FETCH_ORDERS });
  if (mockup) {
    return dispatch({ type: FETCH_ORDERS_SUCCESS, payload: data });
  } else {
    return callApi
      // .getSecurity(
      //   "/order?project_id=" +
      //   params.project_id +
      //   "&customer_id=" +
      //   params.customer_id
      // )
      .postSecurity(
        "/order",
        { project_id: params.project_id, customer_id: params.customer_id }
      )
      .then(res => {
        dispatch({ type: FETCH_ORDERS_SUCCESS, payload: res });
      })
      .catch(error => dispatch({ type: FETCH_ORDERS_FAILURE }));
  }
};

export const deleteOrders = (id, customer_id) => dispatch => {
  dispatch({ type: DELETE_ORDERS });
  if (mockup) {
    return dispatch({ type: DELETE_ORDERS_SUCCESS, payload: id });
  } else {
    return callApi
      .deleteSecurity("/order/" + id + "/" + customer_id)
      .then(res => {
        dispatch({ type: DELETE_ORDERS_SUCCESS, payload: id });
      })
      .catch(error => dispatch({ type: DELETE_ORDERS_FAILURE }));
  }
};

export const toggleDocModal = data => dispatch => {
  return dispatch({ type: TOGGLE_DOC_MODAL, payload: data });
};

export const toggleDetailModal = data => dispatch => {
  return dispatch({ type: TOGGLE_DETAIL_MODAL, payload: data });
};

export const updateDoc = data => dispatch => {
  dispatch({ type: UPDATE_DOC });
  if (mockup) {
    return dispatch({ type: UPDATE_DOC_SUCCESS, payload: data });
  } else {
    return callApi
      .patchSecurity("/document/" + data.order_id, data)
      .then(res => {
        console.log(res);
        dispatch({ type: UPDATE_DOC_SUCCESS, payload: res });
      })
      .catch(error => dispatch({ type: UPDATE_DOC_FAILURE, err: error }));
  }
};

export const orderApprove = param => dispatch => {
  console.log('orderApprove Funct');
  dispatch({ type: ORDER_APPROVE });
  if (mockup) {
    console.log('is mockup');
    return dispatch({ type: ORDER_APPROVE_SUCCESS, payload: data });
  } else {
    return callApi
      .patchSecurity("/order/approve", param)
      .then(res => {
        console.log('ORDER_APPROVE_SUCCESS');
        dispatch({ type: ORDER_APPROVE_SUCCESS });
      })
      .catch(error => dispatch({ type: ORDER_APPROVE_FAILURE }));
  }
};

export const addCartItem = params => dispatch => {
  dispatch({ type: ADD_ORDER_ITEM });
  if (mockup) {
    return dispatch({ type: ADD_ORDER_ITEM_SUCCESS, payload: data });
  } else {
    return callApi
      .postSecurity("/order/add", params)
      .then(res => {
        dispatch({ type: ADD_ORDER_ITEM_SUCCESS, payload: res });
      })
      .catch(error => dispatch({ type: ADD_ORDER_ITEM_FAILURE }));
  }
};

export const updateDetail = data => dispatch => {
  dispatch({ type: UPDATE_DETAIL });
  if (mockup) {
    return dispatch({ type: UPDATE_DETAIL_SUCCESS, payload: data });
  } else {
    return callApi
      .patchSecurity("/order/" + data.order_id, data.order_detail)
      .then(res => {
        dispatch({ type: UPDATE_DETAIL_SUCCESS, payload: data });
      })
      .catch(error => dispatch({ type: UPDATE_DETAIL_FAILURE }));
  }
};
